import { BANK_TRANSFER_NETWORK } from '~/types'

export enum DEPOSIT_INSTRUCTIONS_ACTIONS {
  SET_IS_COMMENT_FULLNAME_ENABLED = 'DEPOSIT_INSTRUCTIONS.SET_IS_COMMENT_FULLNAME_ENABLED',
  SET_IS_FAST_LIVE_BANNER_ENABLED = 'DEPOSIT_INSTRUCTIONS.SET_IS_FAST_LIVE_BANNER_ENABLED ',
  SET_SELECTED_TAB_NETWORK = 'DEPOSIT_INSTRUCTIONS.SET_SELECTED_TAB_NETWORK',
}

type SetIsFastLiveBannerEnabled = {
  type: typeof DEPOSIT_INSTRUCTIONS_ACTIONS.SET_IS_FAST_LIVE_BANNER_ENABLED
  isFastLiveBannerEnabled: boolean
}

type SetSelectedTab = {
  type: typeof DEPOSIT_INSTRUCTIONS_ACTIONS.SET_SELECTED_TAB_NETWORK
  selectedTabNetwork: BANK_TRANSFER_NETWORK
}

export type ActionTypes = SetIsFastLiveBannerEnabled | SetSelectedTab
